// extracted by mini-css-extract-plugin
module.exports = {"grid":"MenuSubCategoryView_grid__3kxs-","gridMobile":"MenuSubCategoryView_gridMobile__4uzyI"};